const styles = theme => ({
  page: {
    display: 'flex',
    justifyContent: 'center',
    padding: '40px 24px',
    [theme.breakpoints.down('sm')]: {
      padding: '24px 16px',
    },
  },
  content: {
    width: '100%',
    maxWidth: 800,
    display: 'flex',
    flexDirection: 'column',
    gap: 40,
  },
})

export default styles
